class Head {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData();
    }
}

module.exports = {
    constructor: Head,
    watcher: {
        title: ['title'],
        description: ['description']
    }
};



// WEBPACK FOOTER //
// ./components/layout/head/index.js